import Vue from 'vue';
import { Component, Prop, Watch } from 'vue-property-decorator';
import tlp from './pickupLocation.vue';
import tmsServiceBackend from '../../services/axios/tmsServiceBackend';
import qs from 'qs';
@Component({
    name: 'DefaultSelect',
    mixins: [tlp],
    components: {},
    filters: {
        filtersName(value: any, filterKey: any) {
            if (value[filterKey]) return value[filterKey];
            else return value;
        },
    },
})
export default class PickupLocation extends Vue {
    selectdata: any = [];
    searchParams: any = {
        companyName: '',
    };

    @Prop({
        default: '',
    })
    placeholder: string;

    @Prop({
        default: '',
    })
    value: any;

    @Prop({
        default: '',
    })
    filterKey: string;

    @Prop({
        default: false,
    })
    allowClear: boolean;

    @Prop({
        default: '',
    })
    addClass: string;

    @Prop({
        default: false,
    })
    error: any;

    priSelectdata: Array<any> = [];
    isFocused: boolean = false;
    isSelect: boolean = false;
    isHandleBin: boolean = false;
    transitionValue: any = '';
    inputData = '';

    @Watch('error')
    getError(val: any, oldVal: any) {}

    @Watch('value')
    getValue(val: any, oldVal: any) {
        if (!val) {
            this.transitionValue = '';
        } else {
            this.assignmentTransitionValue(val);
        }
    }

    @Watch('inputData')
    getInputData(val: any, oldVal: any) {
        this.searchParams.companyName = val;
        this.getLocationList();
    }

    private assignmentTransitionValue(value: any) {
        this.selectdata.forEach((data: any) => {
            if (value == data[this.filterKey]) this.transitionValue = data;
        });
    }

    mounted() {
        this.getLocationList();
    }

    getLocationList() {
        tmsServiceBackend.get(`/address/getAddressList?${qs.stringify(this.searchParams)}`).then(
            (res: any) => {
                this.selectdata = res.data.data.data;
                this.assignmentTransitionValue(this.value);
                if (this.selectdata) this.priSelectdata = this.selectdata;
            },
            (err: any) => {
                console.log(err);
            }
        );
    }

    handleFocus() {
        this.isFocused = true;
        this.isHandleBin = true;
        this.isSelect = true;
    }

    handleBlur(isValidate: any) {
        this.isSelect = false;
        this.isFocused = false;
        this.isHandleBin = false;
    }
    onItemSelect(item: any) {
        this.isSelect = false;
        this.isFocused = false;
        this.isHandleBin = false;
        this.transitionValue = item;
        this.$emit('input', item[this.filterKey]);
        this.$emit('emitChoose', item);
    }
    addAddress() {
        this.$emit('emitaddAddress', true);
    }

    onAllowClear() {
        this.transitionValue = null;
        this.$emit('input', null);
    }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--1!./src/components/pickupLocation/index.ts